var TAslider = (function($) {
    'use strict';

    // Common configuration for all sliders
    const commonConfig = {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        autoplay: window.innerWidth >= 1280,
        autoplaySpeed: 3500,
        pauseOnHover: true,
        pauseOnFocus: true,
        cssEase: 'linear',
        pauseOnDotsHover: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    adaptiveHeight: true,
                    autoplay: false
                }
            }
        ]
    };

    // Function to adjust dot heights for vertical-message slider
    function adjustVerticalDotHeights($slider) {
        if (window.innerWidth >= 1280) {
            const $container = $slider.closest('.slick-type-vertical-message');
            if ($container.length) {
                setTimeout(() => {
                    const $dots = $container.find('.slick-dots li');
                    if ($dots.length > 0) {
                        const totalHeight = 400;
                        const heightPerDot = totalHeight / $dots.length;
                        $dots.each(function() {
                            $(this).css({
                                'height': heightPerDot + 'px',
                                'min-height': heightPerDot + 'px'
                            });
                        });
                    }
                }, 500);
            }
        }
    }

    // Type-specific configurations
    const typeConfigs = {
        testimonial: {
            appendDots: '.slick-type-testimonial .slick-dots-wrapper',
            centerMode: true,
            centerPadding: '200px',
            slidesToShow: 1,
            infinite: true,
            speed: 800, 
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            fade: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        centerMode: false,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                }
            ]
        },
        historical: {
            appendDots: '.slick-type-historical .slick-dots-wrapper',
            centerMode: true,
            centerPadding: '200px',
            slidesToShow: 1,
            infinite: true,
            speed: 800, 
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            fade: false,
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        centerMode: false,
                        centerPadding: '0',
                        slidesToShow: 1
                    }
                }
            ]
        },
        'vertical-message': {
            appendDots: '.slick-type-vertical-message .slick-dots-wrapper',
            adaptiveHeight: false,
            centerMode: false,
            infinite: false,
            fade: true,
            speed: 800,
            cssEase: 'linear',
            dots: true, // Ensure dots are enabled
            customPaging: function(slider, i) {
                return $('<button type="button" />').text('');
            },
            onInit: function(slick) {
                const $slider = $(slick.$slider);
                adjustVerticalDotHeights($slider);
            },
            afterChange: function(event, slick, currentSlide) {
                const $slider = $(slick.$slider);
                adjustVerticalDotHeights($slider);
            },
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        adaptiveHeight: true,
                        fade: true,
                        speed: 800
                    }
                }
            ]
        }
    };

    // Initialize a slider with the given type
    function initSlider($slider, type) {
        // Safety check
        if (!$slider || !$slider.length) return;

        // Destroy existing slider if it's already initialized
        if ($slider.hasClass('slick-initialized')) {
            try {
                $slider.slick('unslick');
            } catch (e) {
                console.warn('Error unslicking slider:', e);
            }
        }

        // Add IntersectionObserver to handle autoplay based on visibility
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && entry.intersectionRatio === 1 && window.innerWidth >= 1280) {
                    $slider.slick('slickPlay');
                } else {
                    $slider.slick('slickPause');
                }
            });
        }, { 
            threshold: 1.0 // Only trigger when 100% of slider is visible
        });

        const config = {
            ...commonConfig,
            ...typeConfigs[type]
        };

        try {
            $slider.slick(config);
        } catch (e) {
            console.error('Error initializing slider:', e);
        }

        observer.observe($slider[0]);

        // Handle window resize for autoplay
        const handleResize = () => {
            if (window.innerWidth >= 1280) {
                if ($slider.is(':visible') && $slider[0].getBoundingClientRect().top >= 0 && 
                    $slider[0].getBoundingClientRect().bottom <= window.innerHeight) {
                    $slider.slick('slickPlay');
                }
            } else {
                $slider.slick('slickPause');
            }
        };

        $(window).on('resize', handleResize);

        // Clean up observer and resize handler when slider is destroyed
        $slider.on('destroy', function() {
            observer.unobserve($slider[0]);
            $(window).off('resize', handleResize);
        });

        if (type === 'vertical-message') {
            $slider.slickAnimation();
        }
        // After initialization, adjust dot heights if needed
        adjustVerticalDotHeights($slider);

        // Also adjust on window resize
        $(window).on('resize', () => {
            adjustVerticalDotHeights($slider);
        });
    }

    function init() {
        // Initialize all sliders
        $('.wrapper__slider').each(function() {
            const $slider = $(this);
            const types = ['testimonial', 'historical', 'vertical-message'];
            
            // Find which type this slider is
            types.forEach(type => {
                if ($slider.hasClass(`slick-slider-${type}`)) {
                    initSlider($slider, type);
                }
            });
        });
    }

    // Initialize on document ready (frontend)
    $(document).ready(init);

    // Initialize in Gutenberg editor
    if (window.acf) {
        // Initialize when block is added
        acf.addAction('append', function($el) {
            const $slider = $el.find('.wrapper__slider');
            if ($slider.length) {
                setTimeout(() => initSlider($slider), 100);
            }
        });

        // Initialize when block preview is rendered
        acf.addAction('render_block_preview/type=slider', function($block) {
            const $slider = $block.find('.wrapper__slider');
            if ($slider.length) {
                setTimeout(() => {
                    const types = ['testimonial', 'historical', 'vertical-message'];
                    types.forEach(type => {
                        if ($slider.hasClass(`slick-slider-${type}`)) {
                            initSlider($slider, type);
                        }
                    });
                }, 100);
            }
        });

        // Re-init on any block changes
        acf.addAction('remount', function() {
            init();
        });
    }

    return {
        init: init,
        initSlider: initSlider
    };

})(jQuery);